import { Action } from 'redux';
import { ViewType } from '../../enums/ViewType';
import { View } from '../../types/View';
import { Page } from '../../enums/Page';
import { NodeType } from '../../enums/NodeType';

const v: View.Setting = null;
type ViewProps = typeof v.props;

export interface ViewModalState extends Partial<Omit<ViewProps, 'type'>> {
  viewType?: ViewType;
  page?: Page;
  card?: View.Card;
  folderRefId?: string;
  parentView?: View.Setting;
  isMyItemsView?: boolean;
  isBoardWithSwimlanes?: boolean;
}

const UPDATE_VIEW_MODAL_STATE = 'UPDATE_VIEW_MODAL_STATE';

export const updateViewModalState = (newState: Partial<ViewModalState>) => ({
  ...newState,
  type: UPDATE_VIEW_MODAL_STATE
});

type ViewModalAction = Action & Partial<ViewModalState>;

const viewModalReducer = (
  state: ViewModalState = {},
  action: ViewModalAction
): ViewModalState => {
  const { type, ...newState } = action;
  switch (type) {
    case UPDATE_VIEW_MODAL_STATE:
      if (newState.page === null) {
        return {};
      }
      if (
        state.data != newState.data &&
        newState.data == NodeType.Item &&
        !newState.fields?.length
      ) {
        newState.fields = [
          'Item.title',
          'Item.itemId',
          'Item.role',
          'Item.keyInitiative',
          'Item.status',
          'Item.author'
        ];
      }
      return { ...state, ...newState };
    default:
      return state;
  }
};

export default viewModalReducer;
